import type { WillowProperty } from "@/web/routes/explore/-types";

/** Minimum / maximum number of target properties a user can pick at once. */
export const MIN_SELECTIONS = 1;
export const MAX_SELECTIONS = 3;

/** Stable external id (catalog dedup key) for a client-side Catskills property. */
export const catskillsExternalId = (p: WillowProperty) => `catskills:${p.id}`;

/** Stable external id (catalog dedup key) for a searched Mapbox address. */
export const searchedExternalId = (mapboxId: string) => `mapbox:${mapboxId}`;
